// A routine or the agent writes activities with no actorId, and so does the
// system, so only a marker in the payload tells the AI-made ones apart.
const AI_ACTOR_NAME = "AI agent"
const SYSTEM_ACTOR_NAME = "System"

export function resolveActivityActorName(
	actorName: string | null | undefined,
	payload: unknown,
): string {
	const actor = actorName?.trim()
	if (actor) return actor

	const record = (payload ?? {}) as Record<string, unknown>
	if (
		typeof record.routineRunId === "string" ||
		record.source === "ai_agent" ||
		record.actor === "agent"
	)
		return AI_ACTOR_NAME

	return SYSTEM_ACTOR_NAME
}
